import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined,
    MinusOutlined
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import ProductForm from "../forms/Product";
import UploadForm from "../forms/Upload";
import ProductView from "../views/Product";
import RemainBarcodes from "../forms/RemainBarcodes";
import OutBarcodes from "../forms/OutBarcodes";

class ProductsPage extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      mainCats: [],
      identifiers: [],
      shelfs: [],
      rows: [],
      types:[],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      subCats: [],
      tags: [],
      exelFile: null,
      uploadLoading: false,
      visibleInventoryModal: false,
      visibleOutBarcodeModal: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();
    this.inventoryRef = React.createRef();
    this.outBarcodeRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterCheckBox, filterMainCat, filterSubCat, filterSearch } =
      this.state;

    if (filterSearch) params.q = SearchFormat(filterSearch);

    if (filterCheckBox) {
      const filter = filterCheckBox.join(",");

      params.image = filter.indexOf("img") >= 0 ? 1 : 0;
      params.category = filter.indexOf("cat") >= 0 ? 1 : 0;
      params.code = filter.indexOf("cod") >= 0 ? 1 : 0;
      params.isVip = filter.indexOf("vip") >= 0 ? 1 : 0;
      params.products_without_price = filter.indexOf("products_without_price") >= 0 ? 1 : 0;
      params.with_count = filter.indexOf("with_count") >= 0 ? 1 : 0;
    }

    if (filterSubCat) params.subCategoryId = filterSubCat;
    else if (filterMainCat) params.categoryId = filterMainCat;

    console.log("params: ", params)
    this.setState({ loading: true });

    API.product
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });

    setTimeout(() => {
      this.formRef.current.handleDidMount(product);
    }, 0);
  };

  showInventoryModal = (product = {}) => {
    this.setState({ visibleInventoryModal: true, selected: product });

    setTimeout(() => {
      this.inventoryRef.current.handleDidMount(product);
    }, 0);
  };

  hideInventoryModal = () => {
    this.setState({ visibleInventoryModal: false });

    setTimeout(() => {
      this.inventoryRef.current.handleWillUnmount();
    }, 0);
  };

  showOutBarcodeModal = (product = {}) => {
    this.setState({ visibleOutBarcodeModal: true, selected: product });

    setTimeout(() => {
      this.outBarcodeRef.current.handleDidMount(product);
    }, 0);
  };

  hideOutBarcodeModal = () => {
    this.setState({ visibleOutBarcodeModal: false });

    setTimeout(() => {
      this.outBarcodeRef.current.handleWillUnmount();
    }, 0);
  };


  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  showUpload = (product = {}) => {
    this.setState({ visibleUpload: true, selected: product });

    setTimeout(() => {
      this.uploadRef.current.handleDidMount(product.id);
    }, 0);
  };

  hideUpload = () => {
    this.setState({ visibleUpload: false });

    setTimeout(() => {
      this.uploadRef.current.handleWillUnmount();
    }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1, pageSize: this.state.pagination.pageSize });
    }, 0);
  };

  handleUpload = (values) => {
    this.setState({ submitting: true });

    API.product
      .addImage(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideUpload();
        this.fetch({ page: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };



  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteImage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.product
          .deleteImage(record.id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    if(this.state.selected.id != undefined){
      API.product
          .update(values, this.state.selected.id)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }else{
      API.product
          .save(values)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }

  };

  handleTableChange = (pagination) => {
    console.log("pagination : ", pagination)
    this.fetch({ page: pagination.current , pageSize: pagination.pageSize});
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    API.category.list({ type: "main" }).then((result) => {
      this.setState({ mainCats: result.data });
    });

    API.tag.list().then((result) => {
      this.setState({ tags: result.data });
    });
    API.productIdentifier.list().then((result) => {
      this.setState({ identifiers: result.data.data });
    });
    API.productRow.list().then((result) => {
      this.setState({ rows: result.data.data });
    });
    API.countType.list().then((result) => {
      this.setState({ types: result.data.data });
    });
    API.shelf.list().then((result) => {
      this.setState({ shelfs: result.data.data });
    });

    if (catId && subCatId) {
      this.setState({
        filterMainCat: parseInt(catId),
        filterSubCat: parseInt(subCatId),
      });
    }

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  }

  handleUploadFile = async () => {
    this.setState({ uploadLoading: true });
    const formData = new FormData();
    formData.append("file", this.state.exelFile);
    try {
      const data = await API.product.excelUpload(formData);
      console.log(data);
    } catch (error) {
      console.log("Error :");
      console.log(error);
      this.setState({ uploadLoading: false });
      if (error.status === true) {
        message.success(`فایل ${this.state.exelFile.name} با موفقیت آپلود شد.`);
        this.setState({ exelFile: null });
      } else {
        message.error("فایل آپلود نشد. دقت شود فایل از نوع اکسل باشد");
      }
    }
  };

  render() {
    const {
      data,
      filterMainCat,
      loading,
      mainCats,
      pagination,
      selected,
      subCats,
      submitting,
      tags,
      visibleDrawer,
      visibleModal,
      visibleUpload,
      exelFile,
        types,shelfs,identifiers,rows, visibleInventoryModal, visibleOutBarcodeModal
    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    console.log("permisions", permissions)
    const columns = [
      {
        title: Resources.image,
        dataIndex: "image",
        width: "50px",
        render: (val) => (
            <Tooltip
                title={
                  <Avatar
                      src={`${Constants.imagePathProduct}${val}`}
                      shape="square"
                      size={200}
                  />
                }
            >
              <Avatar
                  src={`${Constants.imagePathProduct}${val}`}
                  shape="square"
                  size="small"
              />
            </Tooltip>
        ),
      },
      {
        title: Resources.title,
        dataIndex: "name",
      },
      {
        title: Resources.category,
        dataIndex: "category",
        className: "col-center",
        render: (val, record) => {
          let str = "-";

          if (val) {
            str = val.name;

            if (record.sub_category) {
              str = `${str} / ${record.sub_category.name}`;
            }
          }

          return str;
        },
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "130px",
      },
      {
        title: Resources.type,
        dataIndex: "base_type_name",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.shelf,
        dataIndex: "base_shelf_name",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.row,
        dataIndex: "base_row_name",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.identifier,
        dataIndex: "base_identifier_name",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.inventory,
        // dataIndex: "inventory",
        dataIndex: "barcode_count",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.price,
        dataIndex: "priceOne",
        className: "col-center",
        render: (val, record) =>
          `${PriceFormat(val)}`,
      },

      // {
      //   title: Resources.price,
      //   dataIndex: "priceOne",
      //   className: "col-center",
      //   render: (val, record) =>
      //     `${PriceFormat(val)}/${PriceFormat(record.priceTwo)}/${PriceFormat(
      //       record.priceThree
      //     )}`,
      // },
      // {
      //   title: Resources.status,
      //   dataIndex: "status",
      //   className: "col-center",
      //   width: "70px",
      //   render: (val, record) => (
      //     <Switch
      //       size="small"
      //       checked={!!parseInt(val)}
      //       onClick={() => this.handleStatus(record)}
      //       disabled={!permissions.action}
      //     />
      //   ),
      // },
      // {
      //   title: "VIP",
      //   dataIndex: "isVip",
      //   className: "col-center",
      //   width: "70px",
      //   render: (val, record) => (
      //     <Switch
      //       size="small"
      //       checked={!!parseInt(val)}
      //       onClick={() => this.handleVIP(record)}
      //       disabled={!permissions.action}
      //     />
      //   ),
      // },
    ];

    const subColumns = [
      {
        title: Resources.images,
        dataIndex: "image",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`${Constants.imagePathProduct}${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`${Constants.imagePathProduct}${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
    ];

    const options = [

      { label: Resources.ProductsWithoutPrice, value: "products_without_price" },
      { label: Resources.inventory, value: "with_count" },
      // { label: Resources.withoutImage, value: "img" },
      // { label: Resources.withoutCategory, value: "cat" },
      // { label: Resources.withoutBarcode, value: "cod" },
      // { label: Resources.vip, value: "vip" },
    ];

    if (permissions.action) {
      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.view}>
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => this.showDrawer(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showModal(record)}
              />
            </Tooltip>

            <Tooltip title={Resources.remain}>
              <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => this.showInventoryModal(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.out}>
              <Button
                  type="link"
                  icon={<MinusOutlined />}
                  style={{color:"red"}}
                  onClick={() => this.showOutBarcodeModal(record)}
              />
            </Tooltip>
            {/*<Tooltip title={`${Resources.add} ${Resources.image}`}>*/}
            {/*  <Button*/}
            {/*    type="link"*/}
            {/*    icon={<FileImageOutlined />}*/}
            {/*    onClick={() => this.showUpload(record)}*/}
            {/*  />*/}
            {/*</Tooltip>*/}
          </Fragment>
        ),
      });

      subColumns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "80px",
        render: (val, record) => (
          <Tooltip title={Resources.delete}>
            <Button
              type="link"
              icon={<DeleteOutlined />}
              onClick={() => this.handleDelete(record)}
            />
          </Tooltip>
        ),
      });
    }

    const Uploader = () => {
      const props = {
        beforeUpload: (file) => {
          this.setState({
            exelFile: file,
          });
        },
        onChange: (info) => {
          console.log(info.fileList);
        },
      };
      return (
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>آپلود فایل</Button>
        </Upload>
      );
    };

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.products}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
            <Col xs={24} md={6}>
              <Select
                defaultValue={catId ? parseInt(catId) : undefined}
                filterOption
                onChange={(value) => this.handleFilter(value, "filterMainCat")}
                placeholder={Resources.filterByMainCat}
                optionFilterProp="name"
                style={{ display: "block" }}
                showSearch
                allowClear
              >
                {mainCats.map((cat) => (
                  <Select.Option key={cat.id} value={cat.id} name={cat.name}>
                    {cat.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} md={6}>
            {/*  <Select*/}
            {/*    defaultValue={subCatId ? parseInt(subCatId) : undefined}*/}
            {/*    filterOption*/}
            {/*    onChange={(value) => this.handleFilter(value, "filterSubCat")}*/}
            {/*    placeholder={Resources.filterBySubCat}*/}
            {/*    optionFilterProp="name"*/}
            {/*    style={{ display: "block" }}*/}
            {/*    showSearch*/}
            {/*    allowClear*/}
            {/*  >*/}
            {/*    {subCats*/}
            {/*      .filter((o) => parseInt(o.subCategory) === filterMainCat)*/}
            {/*      .map((cat) => (*/}
            {/*        <Select.Option key={cat.id} value={cat.id} name={cat.name}>*/}
            {/*          {cat.name}*/}
            {/*        </Select.Option>*/}
            {/*      ))}*/}
            {/*  </Select>*/}
            </Col>
            <Col xs={24} md={{ span: 6, offset: 6 }}>
              <Tooltip title={Resources.searchHintProduct}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
            <Col xs={24} sm={18} style={{ paddingTop: 16 }}>
             <Checkbox.Group
                options={options}
                onChange={(value) => this.handleFilter(value, "filterCheckBox")}
              />
            </Col>
            <Col xs={24} sm={6} style={{ paddingTop: 16 }}>
              {/* {!!exelFile ? (
                <>
                  <Button onClick={() => this.setState({ exelFile: null })}>
                    <ClearOutlined />
                  </Button>
                  <Button
                    onClick={this.handleUploadFile}
                    loading={this.state.uploadLoading}
                  >
                    آپلود
                  </Button>
                </>
              ) : (
                <Uploader />
              )} */}
            </Col>

            <Col xs={24} md={4}>
              {/*<Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>*/}
            </Col>
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            // expandable={{
            //   expandedRowRender: (record) => (
            //     <Table
            //       columns={subColumns}
            //       dataSource={record.gallery}
            //       pagination={false}
            //       rowKey="id"
            //     />
            //   ),
            //   rowExpandable: (record) => !!record.gallery.length,
            // }}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
        <ProductView
          data={selected}
          visible={visibleDrawer}
          onClose={this.hideDrawer}
        />
        <ProductForm
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}
          rows={rows}
          identifiers={identifiers}
          types={types}
          shelfs={shelfs}
        />

        <RemainBarcodes
            ref={this.inventoryRef}
            onCancel={this.hideInventoryModal}
            onSubmit={this.hideInventoryModal}
            submitting={submitting}
            visible={visibleInventoryModal}
        />

        <OutBarcodes
            ref={this.outBarcodeRef}
            onCancel={this.hideOutBarcodeModal}
            onSubmit={this.hideOutBarcodeModal}
            submitting={submitting}
            visible={visibleOutBarcodeModal}
        />
        <UploadForm
          ref={this.uploadRef}
          onCancel={this.hideUpload}
          onSubmit={this.handleUpload}
          submitting={submitting}
          visible={visibleUpload}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(ProductsPage);
